<accordion>
  <accordion-panel [opened]="true">
    <div panel-header>Search Options</div>
    <div class="grid-x grid-margin-x">
      <div class="cell large-12 medium-12 small-12 bold">
        Organization Identifier Options:
      </div>
      @for (option of identifierOptions; track option) {
        <div class="cell large-4 medium-4 small-4">
          <input type="radio" [(ngModel)]="identifier" id="identifier" [value]="option.id" /> {{option.text}}
        </div>
      }
      <div class="cell large-12 medium-12 small-12 shrink-font">
        {{helpText}}
      </div>
    </div>
    <document-search-options [forceDisableSearch]="requiredKeywords == null" (runSearch)="runQuery($event)" (throwError)="handleError($event)" [requiredKeywords]="requiredKeywords"></document-search-options>
  </accordion-panel>
</accordion>
<div class="margin-top">
  <text-loader [run]="showLoader" [text]="loadingMessage" [interval]="1000" [tickType]="'.'"></text-loader>
  <document-search-results [query]="query" [result]="documents" (pageChanged)="onPageChanged($event)" (sortChanged)="onSorting($event)" (throwError)="handleError($event)"></document-search-results>
</div>
